<ng-container *ngIf="email; else noEmail">
	<a type="button" class="link" target="_blank" [href]="query">
		{{ email | ellipsis: maxCharacters }}
	</a>
</ng-container>
<ng-template #noEmail> N/A </ng-template>
